var _Circle, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
function SvgCircleCheck(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 9,
    cy: 9,
    r: 6.75,
    stroke: "#40AFED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M6.75 9l1.5 1.5 3-3",
    stroke: "#40AFED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCircleCheck;